export default {
  SEND_MESSAGE: 'sendMessage',
  SEND_SHARE_MESSAGE: 'sendShareMessage'
}